import { Component, HostListener, OnInit } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import { AuthenticationService } from './shared/services';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  title = 'JobConnect';
  // showHeader: boolean = false;
  loading: boolean = true;
  currentUrl!: string;

  constructor(
    private primengConfig: PrimeNGConfig,
    public authentication: AuthenticationService,
    private spinner: NgxSpinnerService,
    private router: Router,
  ) {
    this.primengConfig.ripple = true;
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
      )
      .subscribe((event) => {
        const url = event.urlAfterRedirects;
        // '/' is only a redirect hop with no content — never resume it.
        if (!url.includes('/auth') && url !== '/' && !url.startsWith('/?')) {
          localStorage.setItem('lastRoute', url);
        }
      });
  }

  ngOnInit(): void {
    this.router.events.subscribe((routerEvent: Event) => {
      this.currentUrl = this.router.url;
      if (routerEvent instanceof NavigationStart) {
        this.loading = true;
        this.spinner.show();
      }
      if (routerEvent instanceof NavigationEnd) {
        this.loading = false;
        this.spinner.hide();
        this.currentUrl = routerEvent.urlAfterRedirects;
        // Storage may have been cleared since the last page — keep the
        // in-memory user in step so the header doesn't linger.
        this.authentication.syncWithStorage();
      } else if (
        routerEvent instanceof NavigationCancel ||
        routerEvent instanceof NavigationError
      ) {
        this.loading = false;
        this.spinner.hide();
      }
    });
    const loader = document.getElementById('init-loader');
    if (loader) {
      loader.style.opacity = '0';
      setTimeout(() => loader.remove(), 400);
    }
  }

  showFeedback = false;

  openFeedback() {
    this.showFeedback = true;
  }

  closeFeedback() {
    this.showFeedback = false;
  }

  /** Signed in AND not on a public login / register page. */
  get showAppChrome(): boolean {
    return this.authentication.isLoggedIn && !this.isPublicPage;
  }

  get isPublicPage(): boolean {
    const url = this.currentUrl || this.router.url || '';
    return url.startsWith('/auth');
  }

  /** Another tab logged out / cleared storage, or DevTools cleared it. */
  @HostListener('window:storage', ['$event'])
  onStorageChange(event: StorageEvent): void {
    if (event.key !== null && event.key !== 'access_token') return;
    this.checkSessionStillValid();
  }

  /** Coming back to the tab (e.g. after clearing storage in DevTools). */
  @HostListener('window:focus')
  @HostListener('document:visibilitychange')
  onReturnToTab(): void {
    if (document.visibilityState === 'visible') this.checkSessionStillValid();
  }

  private checkSessionStillValid(): void {
    const wasLoggedIn = !!this.authentication.currentUserValue;
    if (wasLoggedIn && !localStorage.getItem('access_token') && !this.isPublicPage) {
      this.authentication.expireSession();
    } else {
      this.authentication.syncWithStorage();
    }
  }

  showHeader(): boolean {
    const verificationRoute = /^\/candidate-assesment\/verification\/.+$/;
    const assessmentRoute = /^\/candidate-assesment\/start-assesment\/.+$/;
    return (
      !verificationRoute.test(this.currentUrl) &&
      !assessmentRoute.test(this.currentUrl)
    );
  }
}
